import { motion, useScroll, useTransform } from "framer-motion";

const Hoof = ({ className }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
    <path d="M7 2.5 C4.2 2.5 2.8 5.6 3.3 9 C3.8 12.4 5.2 14.5 7 14.5 C8.8 14.5 9.6 11.8 9.6 8.2 C9.6 4.8 8.8 2.5 7 2.5 Z" />
    <path d="M17 2.5 C19.8 2.5 21.2 5.6 20.7 9 C20.2 12.4 18.8 14.5 17 14.5 C15.2 14.5 14.4 11.8 14.4 8.2 C14.4 4.8 15.2 2.5 17 2.5 Z" />
  </svg>
);

const Print = ({ scrollY, index, top, left, rotate }) => {
  const start = index * 160;
  const opacity = useTransform(scrollY, [start, start + 240], [0.35, 0]);
  return (
    <motion.div
      style={{ opacity, top, left, rotate }}
      className="absolute text-[#4A3B32]"
    >
      <Hoof className="h-5 w-5" />
    </motion.div>
  );
};

export default function HoofTracks() {
  const { scrollY } = useScroll();
  const prints = Array.from({ length: 10 }, (_, i) => ({
    top: `${6 + i * 9.5}%`,
    left: i % 2 === 0 ? "8px" : "30px",
    rotate: i % 2 === 0 ? -14 : 10,
  }));
  return (
    <div
      data-testid="hoof-tracks"
      className="pointer-events-none fixed inset-y-0 left-0 z-30 w-12"
      aria-hidden="true"
    >
      {prints.map((p, i) => (
        <Print key={i} scrollY={scrollY} index={i} {...p} />
      ))}
    </div>
  );
}
